module.exports = __webpack_public_path__ + "static/img/role-cn.4fd95d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/role-cn.png
// module id = 8O7K
// module chunks = 1